import appState from '../util/appState';
import ajaxBlocks from '../util/ajaxBlocks';
import notie from 'notie';
import Mousetrap from 'mousetrap';
import moment from 'moment';
import Pikaday from 'pikaday';
import 'mousetrap/plugins/global-bind/mousetrap-global-bind';

// Fix Pikadaty format working w/ moment (from https://stackoverflow.com/a/44114938/1001675)
Pikaday.prototype.toString = function (format) {
    return (this._d instanceof Date) ? moment(this._d).format(format || this._o.format) : '';
}

// All elements that are marked as keyboard-navigable
// const tabbable = document.querySelectorAll('[tabindex]');

const common = {
  init() {
    // JavaScript to be fired on all pages

    // Random color to start
    let clrs = document.querySelectorAll('[data-hue]');
    if (clrs) {
      let el = clrs[(Math.floor(Math.random() * clrs.length))];
      document.documentElement.style.setProperty('--hue', el.getAttribute('data-hue'));
    }

    // Auto date-dropdown for inputs.date-picker
    document.addEventListener('focus', e => {
      if (e.target !== document && e.target.matches('input.date-picker')) {
        common.datePickerInit(e.target);
      }
    }, true);

    // Update hourly rate when changing job select in Edit Item form
    document.addEventListener('change', e => {
      if (e.target.matches('select[data-update-hourly-rate]')) {
        let sel = e.target;
        let hourly_rate = sel.options[sel.selectedIndex].getAttribute('data-hourly-rate');
        let form = sel.closest('form');
        if (form.querySelector('input[name="hourly_rate"]')) {
          form.querySelector('input[name="hourly_rate"]').value = hourly_rate;
        }
      }
    });

    document.addEventListener('click', e => {
      // Clicking on flash hides it
      if (e.target.closest('.flash')) {
        e.target.closest('.flash').classList.add('hidden');
      }
      // [data-confirm] elements
      if (e.target.hasAttribute('data-confirm')) {
        if (!confirm('Are you sure?')) {
          e.preventDefault();
        }
      }
    });

    // Init color hovers on frontend homepage
    common.hovers();

    // Init global keyboard support'
    common.keyboardSupport();

  },

  // Init fancy datepickers w/ Pikaday
  datePickerInit(el) {
    if (!el.classList.contains('pikadayed')) {
      el.classList.add('pikadayed');
      new Pikaday({
        field: el,
        format: 'MM/DD/YYYY',
        blurFieldOnSelect: false,
      });
    }
  },

  keyboardSupport() {
    // Keyboard support

    // Bind cmd/ctrl-s to saveForm()
    Mousetrap.bindGlobal(['ctrl+s', 'meta+s'], e => {
      e.preventDefault();
      let openForm = document.querySelector('.ajaxblock form');
      if (openForm) {
        ajaxBlocks.saveForm(openForm);
      }
    });

    // 1,2,3,4 opens items in nav, omitting logout
    let navItems = document.querySelectorAll(`.user-nav li`);
    let navBind = [];
    for (let i = 1; i < navItems.length; i++) {
      navBind.push(i+'');
    }
    Mousetrap.bind(navBind, e => {
      // Any ajax-forms open?
      let formOpen = document.querySelector('.ajaxblock form');
      if (formOpen) {
        formOpen.scrollIntoView();
        notie.alert({
          type: 'error',
          text: 'Please save your changes'
        });
        return false;
      }

      // AJAX request still running?
      if (appState.requestInProgress) {
        notie.alert({
          type: 'error',
          text: 'Something is still running, one sec...'
        });
        return false;
      }

      // Finally, open nth nav item based on keypress
      let navItem = document.querySelector(`.user-nav li:nth-child(${e.key}) a`);
      if (navItem) {
        location.href = navItem.href;
      }
    });

    // Next/prev for ajaxblocks
    Mousetrap.bind(['down', 'j'], e => {
      if (e.key == 'ArrowDown') e.preventDefault();

      // Arrow down to next item
      let focused = document.activeElement;
      let newFocus;
      if (focused == document.body) {
        // If body focused, select first ajaxblock in <main>
        newFocus = document.querySelector('main .ajaxblock');
      } else if (focused.classList.contains('ajaxblock')) {
        newFocus = focused.nextElementSibling;
        // If no next sibling, select first ajaxblock in <main>
        if (!newFocus) {
          newFocus = document.querySelector('main .ajaxblock');
        }
      } else {
        newFocus = $(focused).find('[tabindex]');
        newFocus = newFocus.length ? newFocus[0] : document.querySelector('[tabindex]');
      }
      if (newFocus) {
        newFocus.focus();
        newFocus.scrollIntoView({block: 'center'});
      }

    }).bind(['up', 'k'], e => {
      if (e.key == 'ArrowUp') e.preventDefault();

      // Arrow up to previous item
      let focused = document.activeElement;
      let newFocus;
      if (focused == document.body) {
        // If body focused, select last ajaxblock in <main>
        newFocus = document.querySelectorAll('main .ajaxblock');
        if (newFocus.length)
          newFocus = newFocus[newFocus.length - 1];
      } else if (focused.classList.contains('ajaxblock')) {
        newFocus = focused.previousElementSibling;
        // If no previous sibling, select last ajaxblock in <main>
        if (!newFocus) {
          newFocus = document.querySelectorAll('main .ajaxblock');
          if (newFocus.length)
            newFocus = newFocus[newFocus.length - 1];
        }
      } else {
        newFocus = $(focused).prev('[tabindex]');
        newFocus = newFocus.length ? newFocus[0] : document.querySelector('[tabindex]:last-child');
      }
      if (newFocus) {
        newFocus.focus();
        newFocus.scrollIntoView({block: 'center'});
      }

    });

    // Esc
    Mousetrap.bind(['esc'], e => {
      let focused = document.activeElement;
      if (focused.classList.contains('ajaxblock')) {
        e.preventDefault();
        focused.blur();
      }
    });


  },

  // Handle hovers for weird color effects
  hovers() {
    if (!document.querySelector('body.homepage')) return;

    // Background color changes on .color-hover element hovers
    document.querySelectorAll('.color-hover').forEach((el, index) => {
      if (!el.classList.contains('hovered')) {
        el.classList.add('hovered');
        el.addEventListener('mouseover', ()=> {
          // Pull a color from a [data-hue] element in dom based on index of .color-hover el
          if (!el.getAttribute('data-hue')) {
            let color = document.querySelectorAll('[data-hue]')[index];
            el.setAttribute('data-hue', color.getAttribute('data-hue'));
          }
          document.documentElement.style.setProperty('--hue', el.getAttribute('data-hue'));
        });
        el.addEventListener('mouseleave', ()=> {
          // document.documentElement.style.setProperty('--hue', '');
        });
      }
    });
    // Background color changes on [data-hue] hovers
    document.querySelectorAll('[data-hue]').forEach(el => {
      el.addEventListener('mouseover', ()=> {
        document.documentElement.style.setProperty('--hue', el.getAttribute('data-hue'));
      });
      el.addEventListener('mouseleave', ()=> {
        // document.documentElement.style.setProperty('--hue', '');
      });
    });
  },

  // Helper function to get time (rounded to seconds)
  getTime() {
    return Math.round((new Date()).getTime()/1000);
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    common.hovers();
  },
};

export default common
